var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GenesisRouterConstants } from "../../../configuration/router.constants";
import { autoinject, transient } from "aurelia-framework";
import { Router } from "aurelia-router";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { RequestClient } from "../../../services/basics/request-client.service";
import { I18N } from 'aurelia-i18n';
var ResetPassword = /** @class */ (function () {
    function ResetPassword(requestClient, notificationService, router, i18N) {
        this.requestClient = requestClient;
        this.notificationService = notificationService;
        this.router = router;
        this.i18N = i18N;
        this.email = "";
        this.password = "";
        this.confirmPassword = "";
    }
    ResetPassword.prototype.activate = function (params) {
        this.userId = Number(params.userId);
        this.code = params.token;
    };
    ResetPassword.prototype.submit = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var body = { userId: _this.userId, code: _this.code, password: _this.password, email: _this.email };
            var promise = _this.requestClient.post("User/ResetPassword", {}, body);
            promise.then(function (response) {
                if (response.isSuccess) {
                    _this.notificationService.show(_this.i18N.tr('reset-successful-text'), _this.i18N.tr('password-has-been-successfully-reset-text') + "!", NotificationType.Success, 3000);
                    _this.router.navigateToRoute(GenesisRouterConstants.RouteNames.Login, {}, { replace: true });
                }
                else {
                    _this.notificationService.show(_this.i18N.tr('password-reset-failed-check-email-correct-text'), "", NotificationType.Error, 3000);
                }
                resolve();
            }).catch(function (ex) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('password-reset-failed-text'), NotificationType.Error, 3000);
                resolve();
            });
        });
    };
    ResetPassword = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [RequestClient,
            NotificationClientService,
            Router, I18N])
    ], ResetPassword);
    return ResetPassword;
}());
export { ResetPassword };
